function TableSkeleton({ rows = 8 }) {
    return (
        <div className="divide-y divide-white/[0.04]">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="flex gap-4 px-4 py-3">
                    <div className="h-4 max-w-[120px] flex-1 animate-pulse rounded bg-white/[0.06]" />
                    <div className="h-4 flex-[2] animate-pulse rounded bg-white/[0.06]" />
                    <div className="h-4 w-16 animate-pulse rounded bg-white/[0.06]" />
                    <div className="h-4 flex-1 animate-pulse rounded bg-white/[0.06]" />
                </div>
            ))}
        </div>
    );
}

function ListSkeleton({ rows = 6 }) {
    return (
        <div className="divide-y divide-white/[0.04]">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="flex gap-3 px-4 py-4 sm:px-5">
                    <div className="h-4 flex-1 animate-pulse rounded bg-white/[0.06]" />
                    <div className="h-4 w-24 animate-pulse rounded bg-white/[0.06]" />
                </div>
            ))}
        </div>
    );
}

/**
 * Fixed-height admin content shell — loading/empty/content share identical DOM bounds.
 */
export function AdminPanelShell({
    title,
    count,
    loading,
    empty,
    emptyMessage = "No items yet.",
    variant = "table",
    children,
    headerExtra,
    testId,
}) {
    return (
        <div className="space-y-4" data-testid={testId}>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
                <h2 className="hidden font-heading text-xl tracking-tight lg:block">{title}</h2>
                <div className="flex items-center justify-between gap-3 sm:justify-end">
                    {headerExtra}
                    <span className="w-16 text-right font-mono text-xs tabular-nums text-white/40">
                        {loading ? "…" : `${count ?? 0} total`}
                    </span>
                </div>
            </div>

            <div className="relative flex min-h-[min(420px,calc(100dvh-12rem))] flex-col overflow-hidden surface admin-panel-shell__body md:h-[600px]">
                <div className={`absolute inset-0 flex flex-col overflow-hidden ${loading ? "pointer-events-none invisible" : ""}`}>
                    {empty ? (
                        <div className="relative min-h-0 flex-1">
                            <div className="absolute inset-0 grid place-items-center p-10 text-center text-sm text-white/45">
                                {emptyMessage}
                            </div>
                        </div>
                    ) : (
                        <div className="flex-1 overflow-auto">{children}</div>
                    )}
                </div>
                <div className={`absolute inset-0 overflow-hidden ${loading ? "" : "pointer-events-none invisible"}`} aria-hidden={!loading}>
                    {variant === "table" ? <TableSkeleton /> : <ListSkeleton />}
                </div>
            </div>
        </div>
    );
}

export function AdminInlineLoading({ label = "Loading…" }) {
    return (
        <div className="grid min-h-[min(420px,calc(100dvh-12rem))] place-items-center gap-2 surface text-sm text-white/40 md:h-[600px]">
            <span>{label}</span>
        </div>
    );
}
